/* eslint-disable @typescript-eslint/no-unused-vars */
import { Navigate, useLocation } from "react-router-dom";
import { useCourtBooking } from "../context/courtBookingContext";

const PublicRoute = ({ children }: any) => {
  const { pathname } = useLocation();

  const { isAuthenticated } = useCourtBooking();

  console.log(pathname);

  if (isAuthenticated === null) {
    return <Navigate to={`${pathname}`} />;
  }

  if (isAuthenticated) {
    return <Navigate to="/match-list" />;
  }

  return children;
};

export default PublicRoute;
